import { CellProps } from 'react-table'
import { EmpresasActionsCell } from './EmpresaActionsCell'
import {
  ChipListCell,
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import { EmpresaList } from '../../core/_models'
import { Enum, formatDateToPtBr } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

const empresasColumns = (t: TFunction): ReadonlyArray<TableColumn<EmpresaList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todas desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.nomeFantasia ?? row.original.nome ?? ''}`}
      />
    ),
  },
  // CNPJ é a linha de apoio do nome fantasia; os dois seguem ordenáveis.
  sortableColumn<EmpresaList>({
    id: 'nomeFantasia',
    cellWidth: '320px',
    useQueryRequest,
    fields: [
      { field: 'nomeFantasia', label: t('cols.nomeFantasia') },
      { field: 'cnpj', label: t('cols.documento.cnpj') },
    ],
    Cell: ({ row }) => (
      <StackedCell tabular primary={row.original.nomeFantasia} secondary={row.original.cnpj} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.terminoContrato')}</PlainHeader>,
    id: 'terminoContrato',
    cellWidth: '168px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StackedCell
        tabular
        primary={formatDateToPtBr(row.original.terminoContrato ?? '') || undefined}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.contratos')}</PlainHeader>,
    id: 'tiposContrato',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <ChipListCell
        items={(row.original.tiposContratoMap ?? []).map((item: Enum) => item.descricao)}
        noun={{ singular: 'serviço', plural: 'serviços' }}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.status')}</PlainHeader>,
    id: 'ativa',
    cellWidth: '112px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StatusBadge active={row.original.ativa} labels={['Ativa', 'Inativa']} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<EmpresaList>) => <EmpresasActionsCell empresa={row.original} />,
  },
]

export { empresasColumns }
